// extracted by mini-css-extract-plugin
module.exports = {"myStoreWrapper":"BrowseAllStores_view_myStoreWrapper__hog4Y"};